import React, { memo, useCallback } from 'react'

import { Icon, Add, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import { STUDIO_PATH, iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'

// Selected only on the empty starting screen: /ai-image also hosts a running conversation
// (it has a session) and the full-width editor (an opened image).
function NewImageCard({ onGenerate }) {
  const t = useTranslation()
  const location = useLocation()
  const hasSession = useThreeDStudioStore(state => state.ui.imageGeneratorSessionId != null)
  const hasOpenedImage = useThreeDStudioStore(state => state.ui.openedImage != null)
  const isActive = location?.pathname === STUDIO_PATH.IMAGE_GENERATOR && !hasSession && !hasOpenedImage

  const handleKeyDown = useCallback((event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onGenerate()
    }
  }, [onGenerate])

  return (
    <div
      className={classnames(
        'model-card',
        'model-card--action',
        'model-card--new',
        isActive && 'model-card--active'
      )}
      role="button"
      tabIndex={0}
      aria-label={t('sidebar.actions.generateNewImage')}
      onClick={onGenerate}
      onKeyDown={handleKeyDown}
    >
      <div className="model-card__action">
        <Icon svgComponent={Add} size={iconSizeMedium} color="dark" notSpaced />
        <span className="model-card__action-text">
          {t('sidebar.newImageCard.titleLine1')}
          <br/>
          {t('sidebar.newImageCard.titleLine2')}
        </span>
      </div>
    </div>
  )
}

NewImageCard.propTypes = {
  onGenerate: func.isRequired,
}

export default memo(NewImageCard)
